import { commandProvider, serviceCommands } from '@estee/elc-service-bus';

import { AccountSidebarVisibilityUseCase } from '~use-cases/AccountSidebarVisibilityUseCase';

export class ServiceBusController {
    @commandProvider(serviceCommands.ACCOUNT_OVERLAY_SHOW)
    public showOverlay = async () => {
        await new AccountSidebarVisibilityUseCase(true).execute();
    };

    @commandProvider(serviceCommands.ACCOUNT_OVERLAY_HIDE)
    public hideOverlay = () => {
        const setSidebarVisibility = new AccountSidebarVisibilityUseCase(false);

        setSidebarVisibility.execute();
    };
}
